import { render, staticRenderFns } from "./Alarmvorlagen.vue?vue&type=template&id=96eec1d2"
import script from "./Alarmvorlagen.vue?vue&type=script&lang=js"
export * from "./Alarmvorlagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports